import { render, staticRenderFns } from "./exames-publico.vue?vue&type=template&id=b50336fa&scoped=true"
import script from "./exames-publico.vue?vue&type=script&lang=js"
export * from "./exames-publico.vue?vue&type=script&lang=js"
import style0 from "./exames-publico.vue?vue&type=style&index=0&id=b50336fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50336fa",
  null
  
)

export default component.exports